/* tslint:disable */
/* eslint-disable */
/**
 * Atlas API
 * Atlas API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RequestFilterCountsStandardValues
 */
export interface RequestFilterCountsStandardValues {
    /**
     * 
     * @type {number}
     * @memberof RequestFilterCountsStandardValues
     */
    count?: number;
    /**
     * 
     * @type {string}
     * @memberof RequestFilterCountsStandardValues
     */
    name: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof RequestFilterCountsStandardValues
     */
    values: Array<string>;
}

export function RequestFilterCountsStandardValuesFromJSON(json: any): RequestFilterCountsStandardValues {
    return RequestFilterCountsStandardValuesFromJSONTyped(json, false);
}

export function RequestFilterCountsStandardValuesFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequestFilterCountsStandardValues {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': !exists(json, 'count') ? undefined : json['count'],
        'name': json['name'],
        'values': json['values'],
    };
}

export function RequestFilterCountsStandardValuesToJSON(value?: RequestFilterCountsStandardValues | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'count': value.count,
        'name': value.name,
        'values': value.values,
    };
}


